import { Helpers } from "../Helpers";
import { IDIService } from "../IDIService";

interface IAppLocales {
    GetCurrentLocalesAsync(): Promise<string[] | undefined>;
    SetCurrentLocalesAsync(locale: string): Promise<void>;
}

export interface IAppLocalesService extends IDIService {
    GetCurrentLocalesAsync(): Promise<string[] | undefined>;
    SetCurrentLocalesAsync(locale: string): Promise<void>;
    IsAvailable(): boolean;
}

export class AppLocalesService implements IAppLocalesService {
    public static readonly ServiceName: string = "AppLocalesService";

    GetCurrentLocalesAsync(): Promise<string[] | undefined> {
        if (!this.IsAvailable())
            return Promise.resolve(undefined);

        return ((navigator as any).AppLocales as IAppLocales).GetCurrentLocalesAsync();
    }

    SetCurrentLocalesAsync(locale: string): Promise<void> {
        if (!this.IsAvailable())
            throw new Error("AppLocalesService is not available");

        return ((navigator as any).AppLocales as IAppLocales).SetCurrentLocalesAsync(locale);
    }

    IsAvailable(): boolean {
        return (navigator as any).AppLocales !== undefined || (window as any).webkit?.messageHandlers?.appLocales !== undefined;
    }

    GetServiceName(): string {
        return AppLocalesService.ServiceName;
    }
}